export default "__VITE_ASSET__CbUrXf8g__"